var map = {
	"./Chef Card 6.png": 7805,
	"./Coffee2.png": 2141,
	"./Ellipse 6.png": 3127,
	"./Group 1000002030 (2).png": 6791,
	"./Group 1000002030 (3).png": 7618,
	"./Group 1000002030 (4).png": 8879,
	"./Group 1000002030.png": 4271,
	"./Group.svg": 2719,
	"./Group1.svg": 2544,
	"./Group2.svg": 9342,
	"./Group3.svg": 8470,
	"./Image (2).png": 7664,
	"./Image (3).png": 4497,
	"./Image Placeholder (1).png": 7782,
	"./Image Placeholder (2).png": 765,
	"./Image.png": 2210,
	"./Person.png": 5201,
	"./Rectangle 8796.png": 6875,
	"./Rectangle 8803.png": 704,
	"./Rectangle 8863 (1).png": 9481,
	"./Rectangle 8863 (2).png": 5405,
	"./Rectangle 8863 (3).png": 5327,
	"./Rectangle 8863.png": 8098,
	"./Rectangle 8883.png": 2042,
	"./Student.png": 8181,
	"./about.png": 6440,
	"./about2.png": 7878,
	"./ad.png": 3021,
	"./ataur.png": 8841,
	"./bakery.png": 6826,
	"./bakery2.png": 7285,
	"./banner.png": 14,
	"./banner2.png": 6556,
	"./beans-plantain.jpg": 298,
	"./bisnu.png": 1767,
	"./bistro.png": 7578,
	"./breakfast.jpg": 3264,
	"./burger.png": 8952,
	"./burger2.png": 4237,
	"./cart.jpg": 8621,
	"./cat.png": 90,
	"./cat1.png": 4036,
	"./cat2.png": 748,
	"./cat4.png": 5345,
	"./cheesebutter.png": 7989,
	"./chup.png": 4596,
	"./coffee.png": 6537,
	"./coffee3.png": 3071,
	"./coffee4.png": 8897,
	"./dessert.png": 2933,
	"./drink.png": 2737,
	"./drinks.png": 858,
	"./egusi.jpg": 9020,
	"./fork.png": 197,
	"./fresh-lime.png": 8724,
	"./home-food.png": 3051,
	"./home.png": 2402,
	"./home1.png": 3936,
	"./home2.png": 1829,
	"./homepage.png": 7849,
	"./jorina.png": 836,
	"./kathy.png": 1937,
	"./kets.png": 743,
	"./mahmud.png": 1051,
	"./main.png": 5530,
	"./mohammad.png": 2518,
	"./monalisa.png": 3854,
	"./motin.png": 5680,
	"./muffin.png": 2380,
	"./no-road.jpg": 9774,
	"./noroad.jpg": 3958,
	"./pizza.png": 7105,
	"./restaurant.png": 7178,
	"./sandwich.png": 9103,
	"./screenshot.png": 344,
	"./spaghetti.jpg": 1810,
	"./starter.png": 6541,
	"./tahmina.png": 5970,
	"./tahmina2.png": 7811,
	"./unsplash_-GFCYhoRe48.png": 7601,
	"./unsplash_BsYD6CP0uEw.png": 4169,
	"./unsplash_CLMpC9UhyTo.png": 1421,
	"./unsplash_E6DsqnZbZ4o.png": 8647,
	"./unsplash_INjdgkCwHp0.png": 481,
	"./unsplash_Ioq6qEibtbU.png": 509,
	"./unsplash_JpQGEArmG0I.png": 7084,
	"./unsplash_Lv174o7fn7Y.png": 4578,
	"./unsplash_Y6O6PHJRQms.png": 5286,
	"./unsplash_b75BTzDab9U.png": 9951,
	"./unsplash_dphM2U1xq0U.png": 165,
	"./unsplash_lP5MCM6nZ5A.png": 4757,
	"./unsplash_mmnKI8kMxpc.png": 8819,
	"./unsplash_tzl1UCXg5Es.png": 3524,
	"./william.png": 4897,
	"./wishlist.jpg": 4414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;